import FilterItemModel from "../model/FilterItemModel";
import BaseCollection from "../../../app/library/marionette/collection/BaseCollection";

const FilterCollection = BaseCollection.extend({

    model: FilterItemModel

});

export default FilterCollection;